<template>
  <v-rating
    v-if="hasRating"
    dense
    small
    hover
    clearable
    length="10"
    color="orange"
    backgroundColor="orange"
    :readonly="loading"
    :value="value"
    @input="change"
  />
  <v-btn v-else icon @click="rate"><v-icon>mdi-plus</v-icon></v-btn>
</template>

<script>
export default {
  name: "MyRating",
  props: {
    id: Number,
    rating: Number,
  },
  data() {
    return {
      value: this.rating,
      loading: false,
    }
  },
  inject: ["httpClient"],
  computed: {
    hasRating() {
      return this.rating === 0 || (this.rating > 0 && this.rating <= 10)
    },
  },
  methods: {
    async rate() {
      if (this.loading) return
      this.loading = true
      const update = await this.httpClient.rateFilm({
        id: this.id,
        rating: 0,
      })
      this.$emit("updateFilm", update)
      this.loading = false
    },
    async change(rating) {
      if (this.loading) return
      this.loading = true
      const update = await this.httpClient.rateFilm({
        id: this.id,
        rating,
      })
      this.$emit("updateFilm", update)
      this.value = rating
      this.loading = false
    }
  },
}
</script>
